export interface CreateAppConfigCommand {
  key: AppConfigurationKey;
  appConfigValue: string;
}

export interface UpdateAppConfigCommand {
  id: string;
  key: AppConfigurationKey;
  appConfigValue: string;
}

export interface BannerDto {
  id: string;
  text: string;
  category: string;
  variant: string;
  publishDate: string;
  unpublishDate?: string;
  isActive: boolean;
  customBackgroundColor?: string;
}

export enum AppConfigurationKey {
  Banner = "Banner",
}

export interface AppConfiguration {
  id: string;
  key: AppConfigurationKey;
  value: string;
}
